import { FlexBox } from '@airship-platform/jam-web/components';
import '@airship-platform/jam-web/theme/platform';
import Typography from '@mui/material/Typography';
import { useEnvironmentContext } from '../../contexts/EnvironmentContext';

const allowedBannerEnvs = ['development', 'staging'];

const EnvironmentBanner: React.FC = () => {
  const { env } = useEnvironmentContext();
  if (!allowedBannerEnvs.includes(env)) return null;
  return (
    <FlexBox
      justifyContent="center"
      alignItems="center"
      bgcolor={(theme) => theme.palette.red?.[100]}
      borderRadius={8}
      py={0.5}
      px={2}
    >
      <Typography variant={'body3'} color={'textTertiary'}>
        You are in a testing environment: {env}
      </Typography>
    </FlexBox>
  );
};

export default EnvironmentBanner;
